"use client"

import { useTranslations } from "next-intl"

import { Link } from "@/lib/i18n/navigation"

/**
 * Loyalty program invitation — minimal dark-frame section.
 * The component name is kept as NewsletterSignup for backwards compatibility
 * with existing page compositions that import it.
 */
export function NewsletterSignup() {
  const t = useTranslations("homepage.loyalty")

  return (
    <section className="bg-muted/50" data-loyalty>
      <div className="relative z-10 mx-auto max-w-screen-xl px-6 py-14 md:px-10 md:py-20 lg:px-16 lg:py-24">
        <div className="mx-auto flex max-w-xl flex-col items-center text-center">
          <h2
            className="font-heading text-5xl font-light leading-[1.05] text-balance sm:text-6xl md:text-7xl"
            style={{ fontFamily: "var(--ns-font-heading, inherit)" }}
          >
            L&apos;Atelier
          </h2>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-current/55 text-pretty md:text-base md:leading-[1.7]">
            {t("description")}
          </p>
          <div className="mt-10 md:mt-14">
            <Link
              href="/loyalty"
              className="inline-block border border-current/50 px-8 py-3.5 text-xs font-medium uppercase tracking-[0.2em] text-current/85 transition-colors duration-200 hover:border-current hover:text-current"
            >
              {t("discoverCta")}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
